import Router from 'next/router';
import { exhaustiveGuard } from '@soundxyz/utils';
import { createEnum } from '@soundxyz/utils/const';
import type { ChartTabsType } from '@components/Charts/ChartTabs';
import { DEFAULT_TOP_CHARTS_PATHNAME } from '@pages-shared/topCharts';
import { NAV_LINKS } from '@utils/constants';

export const ViralChartsTypeValues = ['sounds', 'playlists'] as const;
export const ViralChartsType = createEnum(ViralChartsTypeValues);
export type ViralChartsType = (typeof ViralChartsType)[keyof typeof ViralChartsType];

export const handleTypeChange = (type: ChartTabsType) => {
  switch (type) {
    case 'viral': {
      return;
    }
    case 'top': {
      Router.push(DEFAULT_TOP_CHARTS_PATHNAME);
      return;
    }
    default: {
      exhaustiveGuard(type);
    }
  }
};

export const handleContentChange = (type: ViralChartsType) => {
  switch (type) {
    case 'sounds': {
      return Router.push(NAV_LINKS.ViralChartsSounds);
    }

    case 'playlists': {
      return Router.push(NAV_LINKS.ViralChartsPlaylists);
    }

    default: {
      exhaustiveGuard(type);
    }
  }
};
